"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LinearSlideStyle", {
  enumerable: true,
  get: function get() {
    return _linearSlideStyle.LinearSlideStyle;
  }
});
Object.defineProperty(exports, "LinearSlideStyleWithScale", {
  enumerable: true,
  get: function get() {
    return _linearSlideStyleWithScale.LinearSlideStyleWithScale;
  }
});
Object.defineProperty(exports, "CircularSlideStyle", {
  enumerable: true,
  get: function get() {
    return _circularSlideStyle.CircularSlideStyle;
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _slider["default"];
  }
});
var _linearSlideStyle = require("./slide-styles/linear-slide-style");
var _linearSlideStyleWithScale = require("./slide-styles/linear-slide-style-with-scale");
var _circularSlideStyle = require("./slide-styles/circular-slide-style");
var _slider = _interopRequireDefault(require("./slider"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}